"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var union_class_names_1 = require("union-class-names");
var link_1 = require("./svg/link");
var LinkTriggerButton = /** @class */ (function (_super) {
    __extends(LinkTriggerButton, _super);
    function LinkTriggerButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.preventBubblingUp = function (event) { event.preventDefault(); };
        return _this;
    }
    LinkTriggerButton.prototype.render = function () {
        var _a = this.props, theme = _a.theme, onClick = _a.onClick, styleIsActive = _a.styleIsActive, children = _a.children;
        var className = (styleIsActive && styleIsActive())
            ? union_class_names_1.default(theme.button, theme.active)
            : theme.button;
        return (React.createElement("div", { className: theme.buttonWrapper, onMouseDown: this.preventBubblingUp },
            React.createElement("button", { className: className, onClick: onClick, type: "button" },
                React.createElement(link_1.default, null))));
    };
    return LinkTriggerButton;
}(React.Component));
exports.default = LinkTriggerButton;
